import { Component, Prop, Ref } from 'vue-property-decorator'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import ConfigurationLocalAccountingBillableClientsModalRatesBasicFormType from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rates-basic-form/configuration-local-accounting-billable-clients-modal-rates-grid-basic-form'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'
import { BaseCrud } from '@/shared/models/cruds.models'
import { ConfigurationLocalAccountingBillableCustomerBillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-billable-rates-services/configuration-local-accounting-billable-clients-rates.dto'
import { ConfigurationCustomerResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'
import { ConfigurationLocalAccountingCustomerRateGridState, initialLocalAccountingCustomerRatesGridState } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rates/configuration-local-accounting-billable-clients-modal-rates-grid.model'
import { GetContextMenuItemsParams, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import ConfigurationLocalAccountingBillableClientsModalRatesBasicForm from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rates-basic-form/configuration-local-accounting-billable-clients-modal-rates-grid-basic-form.vue'
import { StrictNullable } from '@/shared/types/app.types'

@Component({
    components: {
        VtGrid,
        ConfigurationLocalAccountingBillableClientsModalRatesBasicForm
    }
})
export default class ConfigurationLocalAccountingBillableClientsModalRates extends BaseCrudServerSideComponent<ConfigurationLocalAccountingBillableCustomerBillableRateResponse> implements BaseCrud {
    @Ref() readonly configurationLocalAccountingBillableClientsModalRatesBasicFormWrapper!: ConfigurationLocalAccountingBillableClientsModalRatesBasicFormType
    @Prop() readonly customer!: ConfigurationCustomerResponse

    state: ConfigurationLocalAccountingCustomerRateGridState

    constructor() {
        super()
        this.state = initialLocalAccountingCustomerRatesGridState(this.customer.id)
    }

    get canUpdate(): boolean {
        return this.state.selectedRows.length === 1
    }

    get canDelete(): boolean {
        return !!this.state.selectedRows.length
    }

    private async _deletelocalAccountingBillableRates(requestDelete: EntityIdentifiersRequest): Promise<StrictNullable<EntityIdentifierWithErrorResponse[]>> {
        const ids = requestDelete?.entityIdentifiers
        if (ids?.length) {
            const response = await this.$_toCallUnique(this.state.service.delete(this.state.laboratoryId, requestDelete))
            if (response) {
                const elements = ids.length - response.length
                if (elements > 0) {
                    const choice = elements > 1 ? 2 : 1
                    this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted', choice, { elements }))
                }
                return response
            }
        }
        return null
    }

    /// GRID OPERATIONS ///
    private async _showModalAdviceWhenDelete(): Promise<boolean> {
        const labelConfirmation: string = this.$tc('configuration.grid.deleteConfirmation')
        const selectedRowsSize: number = this.state?.selectedRows?.length
        const labelGrid: string = this.$tc('configuration.grid.element', selectedRowsSize)
        const labelQuestion: string = this.$tc('configuration.grid.deleteQuestion')
        const labelAcceptAction: string = this.$tc('configuration.actions.delete')
        return this.$_showConfirmationModal(
            `${labelConfirmation} ${selectedRowsSize} ${labelGrid}, <br/> ${labelQuestion}`,
            labelAcceptAction
        )
    }

    async deleteOperation(requestDelete: EntityIdentifiersRequest): Promise<void> {
        if (requestDelete) {
            if (await this._showModalAdviceWhenDelete()) {
                if (await this._deletelocalAccountingBillableRates(requestDelete)) {
                    this.reloadData()
                }
            }
        }
    }

    /// GRID EVENT HANDLERS ///
    onUpdate(localAccountingBillableRate: ConfigurationLocalAccountingBillableCustomerBillableRateResponse = this.state.gridApi?.getSelectedRows()[0]): void {
        if (localAccountingBillableRate) {
            this.showModal(this.$tc('configuration.actions.update'), localAccountingBillableRate, this.configurationLocalAccountingBillableClientsModalRatesBasicFormWrapper)
        }
    }

    async onDelete(): Promise<void> {
        if (this.state.selectedRows.length) {
            const requestDelete: EntityIdentifiersRequest = {
                entityIdentifiers: this.state.selectedRows.map(localAccountingBillableRate => localAccountingBillableRate.id as number)
            }
            await this.deleteOperation(requestDelete)
        }
    }

    onAdd(): void {
        this.showModal(
            this.$tc('configuration.actions.add'),
            null,
            this.configurationLocalAccountingBillableClientsModalRatesBasicFormWrapper
        )
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        return [
            {
                name: this.$tc('configuration.actions.update'),
                cssClasses: !this.canUpdate ? ['not-show'] : [''],
                action: () => this.onUpdate(params?.node?.data)
            },
            {
                name: this.$tc('configuration.actions.delete'),
                cssClasses: !this.canDelete ? ['not-show'] : [''],
                action: this.onDelete
            }
        ]
    }
}
